import { defaultFormPost } from "@/common/helpers/postPayload.helper"

function initialState() {
  return {
    post: defaultFormPost(),
    posts: [],
  }
}

let state = initialState()

export { initialState, state }
